import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campJmNew: FaireAdCampaignEntity = {
  token: "camp_jm_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_janmichaels",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 8800,
  startedRunningAt: "2024-06-04",
  segmentMetrics: {
    numCustomersAcquired: 372,
    salesDollars: 254058,
    totalAdsSpendDollars: 36012,
    cpaDollars: 96.81,
    bestEstimateSalesDollars: 248265,
    bestEstimateRoas: 6.89,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
